import {
  CanManageAppGuardService,
  HasCompanyGuardService,
  IsInternalUserGuardService,
} from 'app/services/guards';
import { RouterModule, Routes } from '@angular/router';

import { AppsComponent } from './components/apps/apps.component';
import { AppsDashboardComponent } from './components/apps/apps-dashboard/apps-dashboard.component';
import { AuthErrorComponent } from './components/auth-error/auth-error/auth-error.component';
import { AuthGuard } from 'app/services/auth.service';
import { BlockedUsersComponent } from './components/company/blocked-users/blocked-users.component';
import { BranchesTableComponent } from './components/branches/branches-table/branches-table.component';
import { CallbackComponent } from './components/callback/callback.component';
import { CompanyComponent } from './components/company/company.component';
import { CompanyDetailComponent } from './components/company/company-detail/company-detail.component';
import { InvitesComponent } from './components/invites/invites.component';
import { LoginComponent } from './components/login/login.component';
import { NgModule } from '@angular/core';
import { UserBranchComponent } from './components/branches/user-branch/user-branch.component';
import { UsersComponent } from './components/users/users.component';
import { SsoComponent } from './components/sso/sso.component';
import { BranchAdminsComponent } from './components/branches/branch-admins/branch-admins.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'callback', component: CallbackComponent },
  { path: 'login', component: LoginComponent, canActivate: [AuthGuard] },
  { path: 'apps', component: AppsComponent, canActivate: [AuthGuard] },
  {
    path: 'apps/:client_id',
    component: AppsDashboardComponent,
    canActivate: [AuthGuard],
  },
  { path: 'auth-error', component: AuthErrorComponent },
  { path: 'company', component: CompanyComponent, canActivate: [AuthGuard] },
  {
    path: 'company/:id',
    component: CompanyDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'company/branches/:id',
    component: BranchesTableComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'company/deactivatedUsers/:id',
    component: BlockedUsersComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'company/users/:id/:accountId',
    component: UserBranchComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'company/:companyId/branch/:branchId/admins',
    component: BranchAdminsComponent,
    canActivate: [AuthGuard]
  },
  { path: 'users', component: UsersComponent, canActivate: [AuthGuard] },
  { path: 'invites', component: InvitesComponent, canActivate: [AuthGuard] },
  { path: 'sso', component: SsoComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    CanManageAppGuardService,
    HasCompanyGuardService,
    IsInternalUserGuardService,
  ],
})
export class AppRoutingModule {}
